module.exports = __webpack_public_path__ + "static/media/github-light.36d633ec.svg";